import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';
import {ActivatedRoute} from '@angular/router';
import {DocumentType} from 'src/app/shared/models/user';
import {ApiService} from 'src/app/shared/services/api.service';
import {QrService} from 'src/app/shared/services/qr.service';
import {Request} from 'src/app/shared/models/request';

@Component({
  selector: 'app-success-payment',
  templateUrl: './success-payment.component.html',
  styleUrls: ['./success-payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessPaymentComponent implements OnDestroy {

  params: {
    paymentId: string,
    documentType: DocumentType
  };
  onArrival = false;
  printBtnClicked = false;
  debounceTimer = 10000;
  DocumentType = DocumentType;
  paymentId: string;

  constructor(public nav: NavigateService,
    private cart: CartService,
    private route: ActivatedRoute,
    public api: ApiService,
    public qr: QrService) {
    this.route.queryParams.subscribe((params: any) => {
      this.params = params;
      if(params.paymentId) this.paymentId = params.paymentId;
      this.qr.currentQrData = this.params;
    });
  }

  ngOnInit () {
    if(window.sessionStorage.getItem('lastPaymentId')) {
      this.paymentId = JSON.parse(window.sessionStorage.getItem('lastPaymentId'));
    }

    this.cart.removeStorageOLD(this.api.userRole.isCustomer);
    this.onArrival = true;
    this.setCurrentQrData();
  }

  ngOnDestroy() {
    this.cart.removeStorageOLD();
  }

  printA4() {
    this.printBtnClicked = true;
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  setCurrentQrData() {
    if(this.api.isOnline) {
      return this.api.payment(this.paymentId || this.params.paymentId).then((res: Request) => {
        this.qr.qrOfflineGenerate((this.api.userRole.isWorker || this.api.userRole.isAdmin) ?  this.api.userPlaceId : res.created_place_id, res.id, res.externalId);
        this.qr.setCurrentQrData(undefined, res as Request);
      });
    }
    return Promise.resolve();
  }
}
